import React, { useState, useEffect } from "react";
import styled, { keyframes, css } from "styled-components";

import {
  whiteBgOnClickAnim,
  scaleOnClickAnim,
  rowFadeOutAnim,
  textApearAnim,
} from "../../animations";

// ANIMATIONS

const fadeIn = keyframes`
  0%{
    opacity: 0;
  }
  100% {
    opacity: 1;
    animation-timing-function: cubic-bezier(0.5, 0, 0, 1);

  }
`;
const fadeOut = keyframes`
  0%{
    opacity: 1;
  }
  100% {
    animation-timing-function: cubic-bezier(0.5, 0, 0, 1);
    opacity: 0;
  }
`;

const btnStop = keyframes`
  0% {
    transform: translateX(185px);
  }
  100% {
    animation-timing-function: cubic-bezier(0.5,0,0,5);
    transform: translateX(0px);
  }
`;

const playBtnFromStop = keyframes`
  0% {
    width: 288px;
    background: transparent;
    transform: translateX(30px);
  }
  16% {
    background: #ffb000;
    animation-timing-function: cubic-bezier(0.5,0,0,1);

  }
  100%{
    transform: translateX(0px);
    background: #ffb000;
    width: 248px;
    animation-timing-function: cubic-bezier(0.5,0,0,1);
  }
`;

const loadingloop = keyframes`
    0% {
      stroke-dashoffset: 534.7;
      stroke-dasharray: 0, 634.7;
    }
    10% {      
      stroke-dasharray: 124.7, 510;
    }
    50% {
      stroke-dashoffset: -100;
      stroke-dasharray: 124.7, 510;
    }
    100% {
      stroke-dashoffset: -734.7;
      stroke-dasharray: 0, 634.7;
    }
`;
const loadingloopAnim = css`
  ${loadingloop}
`;
const playBtnFromStopAnim = css`
  ${playBtnFromStop}
`;
const BtnStopAnim = css`
  ${btnStop}
`;
const fadeInAnim = css`
  ${fadeIn}
`;
const fadeOutAnim = css`
  ${fadeOut}
`;

//
export const FooterContainer = styled.div`
  color: #ff3920;
  font-size: 20px;
  pointer-events: ${(p) => (p.isDisabled ? "none" : "auto")};
`;
export const FooterRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  overflow: hidden;
  &&.row {
    animation: ${(p) => (p.rowAnim ? rowFadeOutAnim : textApearAnim)};
    animation-duration: ${(p) => (p.rowAnim ? "0.217s" : "0.6s")};
    animation-fill-mode: forwards;
    display: ${(p) => p.rowAnim && "none"};
    margin-bottom: 18px;
  }
`;
export const OperationBtn = styled.div`
  height: 56px;
  background: ${(p) => (p.border ? "transparent" : "#ffb000")};
  border: solid 3px;
  border-color: ${(p) => (p.border ? "rgb(35, 59, 80);" : "#ffb000")};
  border-radius: 38px;
  color: ${(p) => (p.border ? "rgb(35, 59, 80);" : "#ff3920")};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
  transform: scale(1);
  pointer-events: ${(p) => (p.newDisable ? "none" : "auto")};
  width: ${(p) => (p.btnAnim ? "248px" : "56px")};
  transition: width 0.5s;
  transition-timing-function: cubic-bezier(0.5, 0, 0, 1);
  overflow: hidden;
  .autoRoll {
    width: 32px;
    animation: ${(props) => (props.btnAnim ? fadeOutAnim : fadeInAnim)};
    animation-duration: 0.217s;
    animation-fill-mode: forwards;
    position: absolute;
  }
  :after {
    content: "";
    position: absolute;
    height: 100%;
    width: 100%;
    transform: scale(1);
    background: #ffffff;
    border: solid 3px #ffffff;
    border-radius: 38px;
    right: 50%;
    bottom: 50%;
    transform: translate(50%, 50%);
    opacity: 0;
    animation: ${(p) => (p.clickAnim ? whiteBgOnClickAnim : null)};
    animation-duration: 0.5s;
  }
  animation: ${(p) =>
    p.clickAnim ? scaleOnClickAnim : p.isStoped ? BtnStopAnim : null};
  animation-duration: ${(p) => (p.isStoped || p.btnAnim ? "0.5s" : "0.33s")};
  .cashout {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    animation: ${(props) => (props.btnAnim ? fadeInAnim : fadeOutAnim)};
    animation-duration: 0.13s;
    animation-fill-mode: forwards;
    span {
      font-size: 10px;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    svg {
      height: 10px;
      margin-left: 3px;
      path {
        fill: ${(p) => (p.border ? "rgb(35, 59, 80)" : "#ff3920")};
      }
    }
  }
  &&.active {
    animation: ${scaleOnClickAnim} 0.33s;
    :after {
      animation: ${whiteBgOnClickAnim} 0.5s;
    }
  }
`;

export const MainBtn = styled.div`
  background: ${(p) => (p.isStoped ? "transparent" : "#ffb000")};
  border: solid 3px #ffb000;
  border-radius: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: ${(p) => (p.isStoped ? "unset" : "100%")};
  max-width: ${(p) => (p.isStoped ? "unset" : "248px")};
  width: 100%;
  height: 56px;
  font-size: 20px;
  cursor: pointer;
  position: relative;
  animation: ${(p) =>
    p.clickAnim ? scaleOnClickAnim : p.isStoped ? playBtnFromStopAnim : null};
  animation-duration: ${(p) =>
    p.isStoped ? "0.5s" : p.playA ? "0.33s" : "0.5s"};
  animation-fill-mode: forwards;
  width: ${(p) => (p.btnAnim ? "56px" : "248px")};
  transition: width 0.5s;
  transition-timing-function: cubic-bezier(0.5, 0, 0, 1);
  pointer-events: ${(p) => (p.newDisable ? "none" : "auto")};
  svg {
    width: 28px;
    position: absolute;
    opacity: 0;
    animation: ${(p) => (p.btnAnim ? fadeInAnim : fadeOutAnim)};
    animation-duration: 0.13s;
    animation-fill-mode: forwards;
  }
  p {
    opacity: ${(p) => (p.isStoped || p.btnAnim ? "0" : "1")};
    animation: ${(p) => (p.btnAnim ? fadeOutAnim : fadeInAnim)};
    animation-duration: ${(p) => (p.isStoped ? "0.25s" : "0.217s")};
    animation-fill-mode: forwards;
  }
  span {
    display: block;
    position: absolute;
    width: 100%;
    text-align: center;
    color: #ffb000;
    opacity: 0;
    animation: ${(p) => (p.isStoped ? fadeOutAnim : null)};

    animation-duration: 0.16s;
    animation-fill-mode: forwards;
  }
  :after {
    content: "";
    position: absolute;
    height: 100%;
    width: 100%;
    transform: scale(1);
    background: #ffffff;
    border: solid 3px #ffffff;
    border-radius: 38px;
    opacity: 0;
    animation: ${(p) => (p.clickAnim ? whiteBgOnClickAnim : null)};
    animation-duration: 0.5s;
    animation-fill-mode: forwards;
  }
`;

export const BalanceBtn = styled.div`
  border: solid 3px #ffb000;
  color: #ffb000;
  border-radius: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 0 5px;
  cursor: pointer;
  position: relative;
  height: 56px;
  max-width: 178px;
  font-size: 12px;
  pointer-events: ${(p) => (p.isDisabled ? "none" : "auto")};
  p {
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    text-align: center;
    white-space: nowrap;
    display: flex;
    align-items: center;
    justify-content: center;
    svg {
      margin-left: 4px;
      path {
        fill: #ffb000;
      }
    }
  }
  :after {
    content: "";
    position: absolute;
    height: 100%;
    width: 100%;
    transform: scale(1);
    background: #ffffff;
    border: solid 3px #ffffff;
    border-radius: 38px;
    opacity: 0;
    animation: ${(p) => p.clickAnim && whiteBgOnClickAnim};
    animation-duration: 0.5s;
  }
`;
export const StopFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 58px;
  width: 315px;
  scrollbar-width: none;
  position: relative;
  cursor: pointer;
  margin: auto;
  animation: startAnim 0.55s forwards;
  will-change: transform;
  cursor: pointer;
  .loading-spinner {
    #infinite,
    #background,
    #nonInfinite {
      stroke-width: 3px;
      stroke-linecap: round;
    }
    #background {
      stroke: #233b50;
    }
    #infinite {
      stroke: #ffb000;
      stroke-dasharray: 114.7, 500;
      stroke-dashoffset: 534.7;
      animation: ${loadingloopAnim} 4s linear infinite;
      #text {
        font-size: 18px;
        transform: translateX(120px);
      }
      #bet {
        font-size: 10px;
      }
    }
    #nonInfinite {
      stroke: #ffb000;
      stroke-dashoffset: -112;
      transition: all 1s linear;
      ${(p) =>
        p.myWidth
          ? `stroke-dasharray: ${p.myWidthReverse} ${p.myWidth};`
          : p.myWidth === 0
          ? "stroke-dasharray:  634.7, 0;"
          : "stroke-dasharray: 0, 634.7;"}
      animation: initAnim;
      animation-duration: 1s;
      animation-timing-function: linear;

      @keyframes initAnim {
        from {
          stroke-dasharray: 0, 634.7;
        }
        to {
          stroke-dasharray: 0, (634.7 / ${(p) => p.betTotal});
        }
      }
      @-webkit-keyframes initAnim {
        from {
          stroke-dasharray: 0, 634.7;
        }
        to {
          stroke-dasharray: 0, ${(p) => p.test};
        }
      }
    }
    #back {
      opacity: 0;
      animation: ${(props) => (props.stopA ? whiteBgOnClickAnim : null)};
      animation-duration: 0.5s;
    }
  }

  svg {
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
  #text {
    font-size: 20px;
    transform: translateX(156px);
  }
  #bet {
    font-size: 12px;
    position: absolute;
    right: 50%;
    transform: translateX(50%) translateY(10px);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffb000;
    svg {
      margin-left: 4px;
      width: 10px;
      height: 10px;
    }
  }
  @keyframes startAnim {
    0% {
      transform: scale(0.65);
      animation-timing-function: cubic-bezier(0.17, 0.12, 0.09, 0.96);
    }
    27% {
      transform: scale(1.0293);
      animation-timing-function: cubic-bezier(0.29, 0.44, 0.62, 1);
    }
    100% {
      transform: scale(1);
    }
  }
`;

export const Stop = ({
  handleStop,
  stopAnim,
  setStopAnimation,
  betCount,
  betTotal,
  toggleIsDisabled,
  ubet,
  currencyIcon,
  playStopSFX,
}) => {
  const [dashWidth, setDashwidth] = useState(null);
  const [dashWidthR, setDashwidthR] = useState(0);
  const [isInfinite, setIsInfinite] = useState(false);
  const [test, setTest] = useState(0);

  let StopStyle = {
    display: "none",
  };
  useEffect(() => {
    if (parseInt(betTotal) > 0) {
      setIsInfinite(false);
      if (betCount < parseInt(betTotal) && dashWidth >= 0) {
        setDashwidth(
          634.7 -
            634.7 / parseInt(betTotal) -
            (634.7 / parseInt(betTotal)) * betCount >=
            0
            ? 634.7 -
                634.7 / parseInt(betTotal) -
                (634.7 / parseInt(betTotal)) * betCount
            : 0
        );
        setDashwidthR(
          634.7 / parseInt(betTotal) + (634.7 / parseInt(betTotal)) * betCount
        );
        setTest(634.7 / parseInt(betTotal));
      }
    } else {
      setIsInfinite(true);
    }
  }, [dashWidth, betCount, betTotal]);

  return (
    <StopFooter
      stopA={stopAnim}
      myWidth={dashWidth}
      myWidthReverse={dashWidthR}
      isInf={isInfinite}
      betTotal={betTotal}
      test={test}
      onClick={() => {
        toggleIsDisabled(true);
        setStopAnimation();
        playStopSFX();
        setTimeout(() => {
          handleStop();
        }, 300);
      }}
    >
      <svg style={StopStyle}>
        <defs>
          <symbol id="loopingPath" viewBox="-2 -2 289 60">
            <path
              d="M27.143,0H257.857C272.848,0,285,12.536,285,28s-12.152,28-27.143,28H27.143C12.152,56,0,43.464,0,28S12.152,0,27.143,0Z"
              fill="none"
            />
          </symbol>
          <symbol id="back" viewBox="-2 -2 289 60">
            <path
              d="M27.143,0H257.857C272.848,0,285,12.536,285,28s-12.152,28-27.143,28H27.143C12.152,56,0,43.464,0,28S12.152,0,27.143,0Z"
              stroke="none"
              fill="#ffffff"
            />
          </symbol>
        </defs>
      </svg>
      <svg className="loading-spinner">
        <use id="background" xlinkHref="#loopingPath" />
        {isInfinite ? (
          <use id="infinite" xlinkHref="#loopingPath" />
        ) : (
          <use id="nonInfinite" xlinkHref="#loopingPath" />
        )}
        <use id="text" xlinkHref="#text" />
        <use id="back" xlinkHref="#back" />
        <g id="text">
          <text textAnchor="middle" y="30" fontSize="20" fill="#ffb000">
            Stop
          </text>
        </g>
      </svg>
      <p id="bet">
        {ubet} {currencyIcon}
      </p>
    </StopFooter>
  );
};
